/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-05-25 13:19:41
 * @modify date 2021-05-25 13:19:42
 * @desc [description]
 */
module.exports = require('./api_service');
